import React, { Component } from 'react';
import Notificacao from '../Notificacao';
import moment from 'moment';
import {
  firebaseAuth,
  firebaseFire as Libfirebase,
  firebaseStorage
} from '../../helpers/firebase-config';
import { getCidade } from '../../Libs/cidade';
import PrintTemplate from 'react-print';
import HeaderModal from '../../gb-components/HeaderModal';

export default class Atestado extends Component {
  state = {
    comentario: '',
    ref: null,
    alertMsg: null,
    status: null,
    openModal: false,
    cidade: '',
    paciente: null
  };

  componentDidMount() {
    getCidade(this.props.item.profissional.cidade)
      .then(cidade => {
        this.setState({ cidade });
      })
      .catch(error => {
      });

    const { idPaciente } = this.props;
    const {  id } = this.props.item;
    var refPaciente = Libfirebase.collection('paciente').doc(idPaciente);

    Libfirebase.collection('paciente')
      .doc(idPaciente)
      .get()
      .then(doc => {
        this.setState({ paciente: doc.data() });
      });

    var that = this;
    var ref = Libfirebase.collection('paciente')
      .doc(idPaciente)
      .collection('atestado')
      .doc(id);
    that.setState({ ref, refPaciente });
  }
  _setImprimir = () => {
    window.print();
  };
  _sendPaciente = () => {
    alert(
      'Houve um erro ao enviar o e-mail para o paciente! Favor tentar novamente'
    );
  };

  _sendCidade = () => {
    alert(
      'Houve um erro ao enviar o e-mail para a cidade! Favor tentar novamente'
    );
  };
  render() {
    return (
      <div>
        <PrintTemplate>
          <h4>Atestado Médico</h4> <br />
          <br />
          <p>
            Atesto para os devidos fins, a pedido que o Sr.(a){' '}
            {this.state.paciente ? this.state.paciente.nome : ''}, paciente sob
            meus cuidados, foi atendido(a) no dia{' '}
            {moment(this.props.item.atestado.DataAtendimento).format(
              'DD/MM/YYYY'
            )}
            , necessitando de {this.props.item.atestado.Dia}
            {this.props.item.atestado.Dia <= 1 ? ' dia' : ' dias'}.
          </p>
          <p>
            {this.state.cidade.cidade},
            {moment(this.props.item.atestado.DataCriacao).format('DD/MM/YYYY')}
          </p>
        </PrintTemplate>

        <div
          id="react-no-print"
          // className="container"
          // style={{
          //   overflowY: 'scroll',
          //   overflowX: 'hidden',
          //   maxHeight: '80vh'
          // }}
        >
          <div className="col">

           
            <HeaderModal title="Atestado Médico"/>
            <p>
              Atesto para os devidos fins, a pedido que o Sr.(a){' '}
              {this.state.paciente ? this.state.paciente.nome : ''}, paciente
              sob meus cuidados, foi atendido(a) no dia{' '}
              {moment(this.props.item.atestado.DataAtendimento).format(
                'DD/MM/YYYY'
              )}
              , necessitando de {this.props.item.atestado.Dia}
              {this.props.item.atestado.Dia <= 1 ? ' dia' : ' dias'}.
            </p>
            <p>
              <br />
              {this.state.cidade.cidade},{' '}
              {moment(
                this.props.item.atestado.DataCriacao,
                'DD-MM-YYYY'
              ).format('DD/MM/YYYY')}
            </p>
          </div>
          <br />

          {this.state.notifition ? (
            <Notificacao
              msg={this.state.msg}
              nameclass={this.state.nameclass}
            />
          ) : null}

          <div className="gb-row" style={{ width: '100%' }}>
            <div style={{ float: 'right' }}>
              <button
                onClick={() => this._sendCidade()}
                type="button"
                className="btn gb-button-border to-form"
              >
                Enviar E-mail para cidade
              </button>
            </div>

            <div style={{ float: 'right' }}>
              <button
                onClick={() => this._setImprimir()}
                type="button"
                className="btn gb-button to-form ml-3"
              >
                Imprimir
              </button>
            </div>
            
          </div>



        </div>
      </div>
    );
  }
}
